import { render, staticRenderFns } from "./supplier_types.vue?vue&type=template&id=ccb24084&scoped=true&"
import script from "./supplier_types.vue?vue&type=script&lang=js&"
export * from "./supplier_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb24084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccb24084')) {
      api.createRecord('ccb24084', component.options)
    } else {
      api.reload('ccb24084', component.options)
    }
    module.hot.accept("./supplier_types.vue?vue&type=template&id=ccb24084&scoped=true&", function () {
      api.rerender('ccb24084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/supplier_types.vue"
export default component.exports